import { render, staticRenderFns } from "./NewNoticeOrderMayang.vue?vue&type=template&id=7eab3a5c&scoped=true&"
import script from "./NewNoticeOrderMayang.vue?vue&type=script&lang=js&"
export * from "./NewNoticeOrderMayang.vue?vue&type=script&lang=js&"
import style0 from "./NewNoticeOrderMayang.vue?vue&type=style&index=0&id=7eab3a5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eab3a5c",
  null
  
)

export default component.exports